(() => {
  const filterName = 'filter.p.product_type';
  const viewByType = new Map([
    ['Suha hrana', 'dog-dry'],
    ['Mokra hrana', 'dog-wet'],
    ['Priboljški', 'dog-treats']
  ]);
  let scheduled = false;

  const activeView = () => {
    const values = new URL(window.location.href).searchParams.getAll(filterName);
    for (const value of values) {
      if (viewByType.has(value)) return viewByType.get(value);
    }
    return 'default';
  };

  const updateText = (root, selector, value) => {
    const target = root.querySelector(selector);
    if (target && value) target.textContent = value;
  };

  const applyContext = () => {
    scheduled = false;
    const header = document.querySelector('[data-lt-collection-header][data-collection-handle="hrana-za-pse-natural-greatness"]');
    if (!header) return;

    const contextNode = header.querySelector('[data-lt-collection-context]');
    if (!contextNode) return;

    let contexts;
    try {
      contexts = JSON.parse(contextNode.textContent);
    } catch {
      return;
    }

    const view = activeView();
    const context = contexts[view] || contexts.default;
    if (!context) return;

    header.dataset.activeView = view === 'default' ? '' : view;
    updateText(header, '[data-lt-eyebrow]', context.eyebrow);
    updateText(header, '[data-lt-title]', context.title);
    updateText(header, '[data-lt-intro]', context.intro);
    updateText(header, '[data-lt-note]', context.note);

    header.querySelectorAll('.lt-collection-nav__link').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      const linkView = viewByType.get(url.searchParams.get(filterName)) || 'default';
      const sameCollection = url.pathname === window.location.pathname;
      const isActive = sameCollection && linkView === view;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyContext);
  };

  const clearCurrentFacetCache = () => {
    if (typeof FacetFiltersForm === 'undefined' || !Array.isArray(FacetFiltersForm.filterData)) return;
    const sectionId = document.getElementById('product-grid')?.dataset.id;
    if (!sectionId) return;

    const searchParams = window.location.search.slice(1);
    const currentSectionUrl = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    FacetFiltersForm.filterData = FacetFiltersForm.filterData.filter(({ url }) => url !== currentSectionUrl);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyContext, { once: true });
  } else {
    applyContext();
  }

  window.addEventListener('popstate', () => {
    clearCurrentFacetCache();
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);

  const main = document.querySelector('main');
  if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
})();
